module.exports = __webpack_public_path__ + "static/media/pk.3a126471.svg";